import { supabase } from './db';

export const initDatabase = async () => {
  try {
    // Check if database is already initialized
    const { data: existingUsers, error: checkError } = await supabase
      .from('users')
      .select('count');

    // Don't throw error if table is empty, just return true
    if (checkError) {
      console.log('Database is empty or not initialized yet');
      return true;
    }

    return true;
  } catch (error) {
    console.error('Database initialization error:', error);
    // Return true anyway to allow the app to load
    return true;
  }
};